import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";
import AdBanner from "@/components/AdBanner";
import { useLang } from "@/lib/lang";

function LegalHeader({ title }) {
  const { lang, setLang } = useLang();
  return (
    <header className="border-b border-zinc-200 bg-white sticky top-0 z-10">
      <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/">
          <Button variant="outline" size="sm" data-testid="legal-back-btn" className="border-zinc-300">
            <ChevronLeft size={16} className="mr-1" /> {lang === "fr" ? "Retour" : "Back"}
          </Button>
        </Link>
        <div className="font-serif-mystery text-lg text-[#8b6f3d] truncate">{title}</div>
        <div className="flex items-center gap-1 border border-zinc-200 rounded-full px-1 py-1">
          {["fr", "en"].map((code) => (
            <button
              key={code}
              onClick={() => setLang(code)}
              className={`px-3 py-1 rounded-full text-[10px] font-mono-data uppercase tracking-wider transition-colors ${
                lang === code ? "bg-[#8b6f3d] text-white" : "text-zinc-500 hover:text-zinc-900"
              }`}
            >
              {code}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}

export function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-white text-zinc-900 flex flex-col">
      <LegalHeader title={title} />
      <main className="flex-1 max-w-3xl w-full mx-auto px-6 md:px-8 py-12">
        {children}
        <AdBanner testId="legal-bottom-ad" className="mt-12" />
      </main>
      <Footer />
    </div>
  );
}

/* Component to render a titled section with paragraphs */
export function Section({ title, children }) {
  return (
    <section className="mb-8">
      {title && <h2 className="font-serif-mystery text-2xl text-[#8b6f3d] mb-3">{title}</h2>}
      <div className="text-zinc-700 leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export function BulletList({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1 text-zinc-700">
      {items.map((it, i) => <li key={i}>{it}</li>)}
    </ul>
  );
}
